import React from "react";
import Project from "./index";

export function ProjectFinished() {
  return <Project status="Terminé" />;
}